<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        class="card-speech mb-0"
        no-body
      >
        <div class="card-header">
          <div class="header-left">
            <h3>
              Chuyển âm thanh thành văn bản
            </h3>
            <h4 class="text-wrap">
              {{ fileData.filename_original }}
            </h4>
          </div>
        </div>
        <div
          class="editor-text p-1"
          @focusin.stop
        >
          <!-- <editor
            id="tinymceSpeech"
            ref="refTinymceSpeech"
            :init="tinyOptions"
            v-model="transcribeText"
          /> -->
          <div
            id="textSpeech"
            ref="refTinymceSpeech"
            placeholder="Nội dung văn bản"
            rows="3"
            no-resize
            contenteditable="true"
            spellcheck="false"
            class="text-speech"
          />
          <div class="d-flex align-items-center mt-1">
            <div class="text-secondary text-wrap">
              *Chỉnh sửa nội dung nên lưu lại để sử dụng cho lần sau
            </div>
            <div class="editor-actions ml-auto">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="saveChangeText()"
              >
                <feather-icon icon="SaveIcon" /> Lưu lại
              </b-button>
            </div>
          </div>
        </div>
        <template #footer>
          <div
            id="audio-wrapper"
            ref="refAudioWrapper"
            class="speech-control"
          >
            <div class="audio-player">
              <audio
                id="audio-player"
                :ref="audioPlayerRef"
                preload="auto"
                :autoplay="player.playing"
                :muted="player.muted"
                class="d-none"
              >
                <source
                  :src="fileData.file_local"
                  :type="fileData.mimetype"
                >
              </audio>
              <div class="audio-player-control">
                <button class="prev-control">
                  <feather-icon
                    icon="ChevronsLeftIcon"
                    @click="seekBack"
                  />
                </button>
                <button
                  class="play-control"
                  @click="playPause()"
                >
                  <feather-icon
                    v-if="!player.playing"
                    icon="PlayIcon"
                  />
                  <feather-icon
                    v-else
                    icon="PauseIcon"
                  />
                </button>
                <button class="next-control">
                  <feather-icon
                    icon="ChevronsRightIcon"
                    @click="seekTo"
                  />
                </button>
              </div>
              <div class="audio-progress-bar">
                <button class="audio-duration start-time">
                  {{ convertSecondToTimecode(player.start_time) }}
                </button>
                <div class="audio-seek">
                  <div class="seek-control">
                    <vue-slider
                      v-model="currentTime"
                      :tooltip="'always'"
                      width="100%"
                      :height="8"
                      :dot-size="20"
                      class="mr-4"
                      :min="0"
                      :max="player.end_time"
                      :tooltip-formatter="convertSecondToTimecode"
                      :interval="1"
                      @change="handleSlider"
                    />
                  </div>
                </div>
                <button class="audio-duration end-time">
                  {{ convertSecondToTimecode(player.end_time) }}
                </button>
              </div>
              <button
                class="audio-muted"
                @click="muted"
              >
                <feather-icon
                  v-if="!player.muted"
                  icon="Volume2Icon"
                />
                <feather-icon
                  v-else
                  icon="VolumeXIcon"
                />
              </button>
            </div>
            <div class="speech-actions">
              <b-button
                v-if="transcribeStatus !== 4"
                variant="primary"
                :disabled="loading"
                @click="startTranscribe()"
              >

                <b-spinner
                  v-if="transcribeStatus === 2 || transcribeStatus === 3"
                  small
                />
                <feather-icon
                  v-else
                  icon="RotateCwIcon"
                />
                {{ transcribeStatus === 2 || transcribeStatus === 3 ? 'Đang chuyển sang văn bản' : 'Chuyển sang văn bản' }}
              </b-button>
              <b-button
                v-else
                variant="primary"
                @click="addTextToEditor()"
              >
                <feather-icon icon="PlusIcon" /> Thêm vào tin
              </b-button>

            </div>
          </div>
        </template>
      </b-card>

    </b-overlay>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import {
  defaultOptions, apiUpload, apiDownload, insertFileToEditor,
} from '@/libs/initTinymce'
import {
  BCard, BRow, BCol, BButton, BOverlay, BSpinner, BFormTextarea,
} from 'bootstrap-vue'
import {
  ref, toRefs, computed, reactive,
} from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@/@core/utils/utils'
import VueSlider from 'vue-slider-component'
import { io } from 'socket.io-client';
import { getToken } from '@/auth/utils';
// import SocketSpeech from '@/libs/socket.speech';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BButton,
    BOverlay,
    BSpinner,
    Editor,
    VueSlider,
  },
  props: {
    fileData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      player: {
        id: 'audio-player',
        audio: null,
        playing: false,
        muted: false,
        duration: 0,
        start_time: 0,
        end_time: 100,
      },
      socketSpeech: null,
      socketId: '',
      transcribeText: '<p><br></p>',
      transcribeTextParts: [],
      speechLog: '',
      timerCheckTranscribe: [],
    }
  },
  setup(props, context) {
    const link = ref('')
    const extension = ref('')
    const loading = ref(false)
    const file_id = ref('')
    const currentTime = ref(0)
    const audioPlayerRef = ref(null);

    const transcribeStatus = ref({
      get() {
        return this.fileData.transcribe;
      },
      set(val) {
        console.log('set transcribeStatus', val);
      },
    });

    const state = reactive({
      tinyOptions: null,
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    state.tinyOptions = computed(() => {
      const newOptions = { ...defaultOptions }
      if (store.state.app.settings) {
        if (store.state.app.settings.news !== undefined && store.state.app.settings.news.editor_toolbar !== undefined) {
          const icons = store.state.app.settings.news.editor_toolbar.map(({ icon }) => icon);
          newOptions.toolbar = icons.join(' ');
        }
        if (store.state.app.settings.app !== undefined && store.state.app.settings.app.logo_mask !== undefined) {
          newOptions.images_mask_logo = store.state.app.settings.app.logo_mask;
        }
      }
      newOptions.content_style = 'body{font-size:14pt;max-width:100%;padding:0 20px;}.image{margin:15px auto;max-width:800px;text-align:center;position: relative;}.image img{max-width:100%;margin:0 0 5px 0;}.image figcaption{text-align:center}.media{text-align:center;margin:auto;max-width:800px}[data-mce-bogus=all]{display:none}.caption{display:block;margin:10px 0 10px 0}img,audio,video,embed,iframe,table {max-width:100%}.image .btnDelete{position:absolute;top:-10px;right:-10px;background: #fff;border: 1px solid #ddd;cursor: pointer;}.text-highlight{background-color: #fe0;}';
      return newOptions;
    });
    console.log('state.tinyOptions', state.tinyOptions);

    return {
      ...toRefs(state),
      link,
      loading,
      extension,
      file_id,
      currentTime,
      audioPlayerRef,
      transcribeStatus,
    }
  },
  watch: {
    '$store.state.speech.isDisconnectSocket': function () {
      this.disconnectSocket();
    },
  },
  mounted() {
    console.log('on mouted this.fileData', this.fileData);
    this.initSocket()
    this.initPlayer()
    document.getElementById('audio-wrapper').addEventListener('keydown', (e) => {
      this.onPlayerControl(e);
    });
    document.getElementById('textSpeech').addEventListener('keydown', (e) => {
      this.onTypeEditor(e);
    });
    document.getElementById('textSpeech').addEventListener('keyup', (e) => {
      this.onTypeEditor(e);
    });
    document.getElementById('textSpeech').addEventListener('click', (e) => {
      if (e.target.classList.contains('speech-text-item')) {
        const list = this.$refs.refTinymceSpeech.querySelectorAll('.speech-text-item');
        const idx = [...list].indexOf(e.target);
        // console.log('idx', idx);
        this.onClickToSeek(idx);
      }
    });
    // console.log('tinymce.activeEditor', tinymce.activeEditor);
    // load text if transcribled
    this.getTranscribeText(this.fileData);
  },
  unmounted() {
    console.log('unmounted');
    // this.disconnectSocket();

    this.clearTimerCheckTranscribe();
  },
  methods: {
    onClickToSeek(idx) {
      const idxPart = idx >= this.transcribeTextParts.length ? this.transcribeTextParts.length - 1 : idx;
      // console.log(this.transcribeTextParts.length, idxPart, this.transcribeTextParts[idxPart]);
      if (this.transcribeTextParts.length && this.transcribeTextParts[idxPart]) {
        const stime = Math.floor(this.transcribeTextParts[idxPart].stime / 1000) + 1;
        this.player.audio.currentTime = stime;
        this.currentTime = stime;
        // console.log('stime', stime);
        this.highlightText()
      }
    },
    onTypeEditor(e) {
      // console.log('e.keyCode', e.keyCode);
      const key = e.which || e.keyCode
      // space
      if (key === 13) {
        e.preventDefault();
      } else {
        this.transcribeText = this.$refs.refTinymceSpeech.textContent
      }
    },
    onPlayerControl(e) {
      e.preventDefault();
      // console.log('e.keyCode', e.keyCode);
      const key = e.which || e.keyCode
      // space
      if (key === 32) {
        this.playPause()
      }
      // arrow left
      if (key === 37) {
        this.seekBack()
      }
      // arrow right
      if (key === 39) {
        this.seekTo()
      }
    },
    initSocket() {
      // const socketSpeech = SocketSpeech.init(this.fileData, this.generateTextPart);
      // console.log('socketSpeech:', socketSpeech);

      const that = this
      const socketUrl = process.env.VUE_APP_SPEECH_SOCKET || 'http://localhost:3006';
      const socketPath = process.env.VUE_APP_SPEECH_SOCKET_PATH || '/socket.io/';
      const socket = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
      });
      console.log('socketUrl', socketUrl);
      console.log('socketPath', socketPath);
      this.socketSpeech = socket;

      socket.on('connect', () => {
        console.log('socket speech on connect');
        this.socketId = socket.id;
      });
      socket.on('file-transcribed', (data) => {
        // console.log('socket on file-transcribed data', data);
        if (data && data.id === that.fileData.id) {
          showToast(`Rải băng ${that.fileData.filename_original} thành công`, { variant: 'success' });
          // console.log('data.file_id, this.fileData.id', data.id, that.fileData.id);
          // const jsonPretty = JSON.stringify(data, null, 2);
          // const payload = {
          //   fileName: data.fileName,
          //   fileData: data.fileData,
          //   provider: data.provider,
          // }
          if (data.transcribe) {
            that.updateTranscribeStatus(data.transcribe);
            this.getFileTranscribe();
          }

          // if (data.type === 'convert_progress') {
          //   if (data.audio_id) {
          //     that.fileData.transcribe = data.status;
          //     console.log('<p>on convert_progress</p>');
          //   }
          // }

          // if (data.type === 'convert_success') {
          //   // that.$emit('update-transcribe-status', { id: that.fileData.file_id, transcribe: data.status });
          //   console.log('<p>socket speech on convert_success</p>');
          //   socket.emit('transcrible', payload);
          //   console.log('<p>Emit to socket transcrible</p>');
          // }

          // if (data.type === 'transcribe_completed') {
          //   if (data.audio_id) {
          //     // that.$emit('update-transcribe-status', { id: that.fileData.file_id, transcribe: data.status });
          //     console.log('<p>socket speech on transcribe_completed</p>');
          //     that.generateTextPart(data.text_parts)
          //   }
          // }
          // console.log(`<p>${jsonPretty}</p>`);
        }
      });
      socket.on('test-send-message', () => {
        showToast('test send message');
      });
      socket.on('disconnect', () => {
        console.log('socket speech on disconnect');
      });
    },
    initPlayer() {
      // console.log('init player');
      if (this.fileData) {
        this.player.audio = document.getElementById('audio-player');
        this.player.audio.addEventListener('play', (event) => {
          this.player.playing = true;
        });
        this.player.audio.addEventListener('pause', (event) => {
          this.player.playing = false;
        });
        this.player.audio.addEventListener('loadedmetadata', (event) => {
          this.player.end_time = Math.round(this.player.audio.duration);
          // console.log('2 this.player.audio.duration', this.player.audio.duration);
        });

        this.player.audio.addEventListener('timeupdate', (event) => {
          // console.log('The currentTime attribute has been updated. Again. this.player.audio.currentTime', this.player.audio.currentTime);
          this.player.start_time = Math.round(this.player.audio.currentTime)
          this.currentTime = Math.round(this.player.audio.currentTime)
          this.highlightText();
        });
        // console.log('this.player.audio.readyState', this.player.audio.readyState);
        if (this.player.audio.readyState) {
          this.player.end_time = Math.round(this.player.audio.duration);
          this.player.playing = true;
          this.player.audio.play();
        }
      }
    },
    disconnectSocket() {
      if (this.socketSpeech) {
        this.socketSpeech.disconnect();
      }
    },
    startTimerCheckTranscribe() {
      const timer = setTimeout(() => {
        console.log('startTimerCheckTranscribe --> this.fileData.status ', this.fileData.status);
        this.getFileTranscribe();
        this.updateTranscribeStatus(this.fileData.status)

        if (this.fileData.status !== 4) {
          this.startTimerCheckTranscribe();
        } else {
          this.clearTimerCheckTranscribe(this.fileData.id);
        }
      }, 10 * 1000);
      this.timerCheckTranscribe[this.fileData] = timer;
    },
    clearTimerCheckTranscribe(id) {
      if (this.timerCheckTranscribe[id]) {
        clearTimeout(this.timerCheckTranscribe[id]);
      }
    },
    updateTranscribeStatus(status) {
      this.fileData.transcribe = status;
      this.fileData.status = status;
      this.transcribeStatus = status;
      // console.log('update-transcribe-status ', { id: this.fileData.id, transcribe: status });
      this.$emit('update-transcribe-status', { id: this.fileData.id, transcribe: status });
    },
    getFileTranscribe() {
      this.loading = true
      store.dispatch('speech/getFileTranscribe', {
        file_id: this.fileData.id,
      })
        .then(response => {
          this.loading = false
          if (response.data.code === 200) {
            // console.log('response.data.data', response.data.data);
            const { text, text_parts, status } = response.data.data;
            // this.transcribeText = text;
            this.transcribeTextParts = text_parts;
            this.generateTextPart(text_parts);
            this.updateTranscribeStatus(status);

            // console.log('getFileTranscribe status: ', status);
          } else {
            this.updateTranscribeStatus(1);
            // showToast(response.data.message);
          }
        })
    },
    getTranscribeText(fileData) {
      // console.log('fileData', fileData);
      // if (fileData.transcribe !== 4 ) {
      //   this.loading = true
      //   store.dispatch('speech/getTranscribeText', {
      //     file_id: 633, // item.id,
      //     audio_id: '64a77e04cb1c659982e7879e',
      //     provider: 'aimes',
      //   })
      //     .then(response => {
      //       this.loading = false
      //       if (response.data.code === 200) {
      //         console.log('response.data.data', response.data);
      //         const { text, text_parts } = response.data.data;
      //         // this.transcribeText = text;
      //         this.transcribeTextParts = text_parts;
      //         this.generateTextPart(text_parts);
      //         // this.$emit('updateSpeechToText', text)

      //         setTimeout(() => {
      //           this.initPlayer();
      //         }, 1000);
      //       } else {
      //         showToast(response.data.message);
      //       }
      //     })
      // } else {
      this.getFileTranscribe()
      // }
    },
    startTranscribe() {
      // console.log('startTranscribe transcribe/transcribeStatus:', this.fileData.transcribe, this.transcribeStatus);
      if (this.fileData.transcribe === 2 || this.fileData.transcribe === 3) {
        showToast('File đang được xử lý. Vui lòng đợi trong giây lát', { variant: 'success' });
      } else if (this.fileData.transcribe === 1 || this.fileData.transcribe === 5 || this.fileData.transcribe === 6) {
        this.loading = true
        const payload = {
          fileData: {
            id: this.fileData.id,
            fileName: this.fileData.file,
            file: this.fileData.file_local,
            access_token: getToken(),
          },
          file: this.fileData.file_local,
          provider: 'aimes',
          stage: 'upload_and_convert',
        }
        this.updateTranscribeStatus(2);
        // console.log('this.fileData.transcribe', this.fileData.transcribe);
        this.loading = false
        // this.$emit('update-transcribe-status', { id: this.fileData.file_id, transcribe: this.fileData.transcribe });

        store.dispatch('speech/startTranscribe', payload)
          .then(response => {
            // console.log('startTranscribe res', response)
            this.loading = false
            const { code, message, data } = response.data;
            if (code === 200) {
              this.updateTranscribeStatus(data.status);
              // this.fileData.transcribe = data.status;
              // this.$emit('update-transcribe-status', { transcribe: this.fileData.transcribe });
              // console.log('this.fileData.transcribe', this.fileData.transcribe);

              // watching every 10s to get text
              // this.startTimerCheckTranscribe();
            } else {
              showToast(message);
            }
          })
      }
    },
    generateTextPart(text_parts) {
      let html = '';
      this.transcribeTextParts = text_parts || this.transcribeTextParts;
      // console.log('generateTextPart: ', this.transcribeTextParts.length, this.transcribeTextParts);
      if (this.transcribeTextParts.length) {
        this.transcribeTextParts.forEach((part, index) => {
          const stime = Math.floor(part.stime / 1000);
          const etime = Math.floor(part.etime / 1000);
          const text = part.text.replace(/(<([^>]+)>)/gi, '');
          // const text = part.text.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '');
          if (stime < this.currentTime && this.currentTime <= etime) {
            // console.log('show higlight', stime, etime, part.text);
            html += `<span class="speech-text-item text-highlight" stime="${stime}" etime="${etime}"> ${text} </span>`;
          } else {
            html += `<span class="speech-text-item" stime="${stime}" etime="${etime}"> ${text} </span>`;
          }
        });
      }
      this.transcribeText = html;
      // console.log('html', html);
      if (this.$refs.refTinymceSpeech) {
        this.$refs.refTinymceSpeech.innerHTML = html;
      }

      // console.log('tinymce ', tinymce.get('tinymceSpeech'));
      // this.$refs.refTinymceSpeech.editor.setContent(html);
      // tinymce.get('tinymceSpeech').setContent(html, { format: 'raw' });
      // tinymce.activeEditor.insertContent(html);
      // this.transcribeText = html;
      // console.log('this.transcribeText', this.transcribeText);
    },
    highlightText(text_parts) {
      this.transcribeTextParts = text_parts || this.transcribeTextParts;
      // console.log('this.transcribeTextParts.length', this.transcribeTextParts.length, this.transcribeTextParts);
      if (this.transcribeTextParts.length) {
        let indexPart = 0;
        this.transcribeTextParts.forEach((part, index) => {
          const stime = Math.floor(part.stime / 1000);
          const etime = Math.floor(part.etime / 1000);
          if (stime < this.currentTime && this.currentTime <= etime) {
            indexPart = index;
            // console.log('indexPart', indexPart);
          }
        });

        const allParts = document.querySelectorAll('.speech-text-item');
        // console.log('allParts', allParts);
        allParts.forEach((el) => {
          el.classList.remove('text-highlight');
        })
        if (allParts[indexPart]) {
          allParts[indexPart].classList.add('text-highlight');
        }
      }
    },
    saveChangeText() {
      this.loading = true
      const text = this.$refs.refTinymceSpeech.textContent;
      this.transcribeText = text;
      const allParts = document.querySelectorAll('.speech-text-item');
      const newTransText = [];
      this.transcribeTextParts.forEach((part, indexPart) => {
        if (allParts[indexPart]) {
          const textPart = allParts[indexPart].textContent;
          part.text = textPart;
          newTransText.push(part);
        }
      });
      this.transcribeTextParts = [...newTransText];
      // console.log('newTransText', this.transcribeTextParts);
      store.dispatch('speech/updateFileTranscribe', {
        file_id: this.fileData.id,
        text,
        text_parts: this.transcribeTextParts,
      })
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            showToast(response.data.message, { variant: 'success' });
          } else {
            showToast(response.data.message);
          }
        })
    },
    addTextToEditor() {
      // console.log('addTextToEditor this.transcribeText = ', this.transcribeText);
      this.fileData.full_path = this.fileData.full_path || this.fileData.file_local;
      insertFileToEditor(this.fileData);
      this.$emit('update-icon', this.fileData);
      this.$emit('update-speech-to-text', this.transcribeText.replace(/(<([^>]+)>)/gi, ''));
      this.hideModal();
    },
    hideModal() {
      // console.log('click hide modal');
      this.$emit('hide-transcribe-modal');
    },
    convertSecondToTimecode(totalSeconds) {
      if (!totalSeconds) {
        return '00:00:00';
      }
      // totalSeconds = Math.round(totalSeconds);
      const totalMinutes = Math.floor(totalSeconds / 60);
      let seconds = Math.floor(totalSeconds % 60);
      let hours = Math.floor(totalMinutes / 60);
      let minutes = Math.floor(totalMinutes % 60);
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;
      return `${hours}:${minutes}:${seconds}`
    },
    handleSlider(val, index) {
      // console.log('handleSlider', val);
      this.player.start_time = val;
      this.player.audio.currentTime = val;
    },
    playPause() {
      const isPlaying = this.player.playing;
      if (!isPlaying) {
        // console.log('this.player.audio', this.player.audio);
        this.player.audio.play();
      } else {
        this.player.audio.pause();
      }
      this.player.playing = !isPlaying;
    },
    muted() {
      this.player.muted = !this.player.muted;
      // console.log('this.player.muted', this.player.muted);
      this.player.audio.muted = this.player.muted;
    },
    seekBack() {
      const prevTime = this.player.start_time - 10;
      // console.log('seekBack prevTime:', prevTime);
      this.player.start_time = prevTime > 0 ? prevTime : 0;
      this.player.audio.pause();
      this.currentTime = this.player.start_time;
      this.player.audio.currentTime = this.currentTime;
      this.player.audio.play();
    },
    seekTo() {
      const nextTime = this.player.start_time + 10;
      this.player.start_time = nextTime < this.player.end_time ? nextTime : this.player.end_time;
      this.player.audio.pause();
      this.currentTime = this.player.start_time;
      this.player.audio.currentTime = this.currentTime;
      this.player.audio.play();
      // console.log('seekTo nextTime:', nextTime);
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-slider.scss';

.card-speech {
  .card-header {
    padding: 1.5rem 1rem;
    background-color: #eee;

    .header-left {
      h3 {
        font-weight: 700;
        margin-bottom: 5px;
      }

      h4 {
        color: #0B438D;
        margin-bottom: 0;
      }
    }
  }

  button {
    border: none;
    outline: none;
    background-color: transparent;
  }

  .speech-control {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .audio-player {
      flex: 1;
    }

  }

  .audio-player {
    display: flex;
    align-items: center;
    font-size: 1.2rem;

    .audio-player-control {
      display: flex;
      align-items: center;
      order: 1;

      .prev-control,
      .next-control {
        padding: 5px;
        cursor: pointer;
      }

      .play-control {
        padding: 10px;
        cursor: pointer;
      }

      svg {
        width: 40px;
        height: 40px;
      }
    }

    .audio-progress-bar {
      display: flex;
      align-items: center;
      order: 2;
      flex: 0 0 70%;

      .audio-seek {
        flex: 1;
        margin: 0 10px;
      }

      .audio-duration {
        margin: 0 10px;
        user-select: none;
      }
    }

    .audio-muted {
      padding: 5px;
      margin: 0 5px;
      cursor: pointer;
      order: 3;

      svg {
        width: 26px;
        height: 26px;
      }
    }
  }

  .editor-actions {
    flex: 0 0 100px;
    text-align: right;
  }

  .speech-actions {
    svg {
      margin-right: 10px;
    }
  }

  .editor-text {
    .text-speech {
      height: 400px;
      border: 1px solid #ddd;
      font-size: 1.3rem;
      padding: 10px;
      border-radius: 5px;
      overflow-y: auto;

      .text-highlight {
        background-color: #fe0;
      }

      @media (max-width: 1366px) {
        height: 350px;
      }
    }
  }

  @media (max-width: 768px) {
    .card-header {
      padding: 1.5rem 1rem;
      background-color: #eee;

      .header-left {
        h3 {
          font-size: 1.2rem;
        }

        h4 {
          font-size: 1rem;
        }
      }
    }

    .editor-text {
      .text-speech {
        font-size: 1.1rem;
      }
    }

    .audio-player {
      .audio-player-control {
        order: 2;
        flex: 1;

        .next-control {}
      }

      .audio-progress-bar {
        order: 1;
        flex: 0 0 100%;

        .audio-duration {
          margin: 0;
          font-size: 1rem;
        }

        .audio-seek {
          flex: 1;
          margin: 0 10px;
        }
      }
    }

    .card-footer {
      padding: 1rem;
    }

    .speech-control {
      flex-wrap: wrap;

      .audio-player {
        flex-wrap: wrap;
      }
    }

    .speech-actions {
      margin-top: 15px;
      flex: 0 0 100%;
      text-align: center;
    }
  }
}
</style>
